import React, { useState, useEffect } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap"
import SButton from "components/Common/Button"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import FabricOrderAction from "store/fabric-order-resource/actions"
import Select from "react-select"
import DateInput from "components/Common/DateInput"
import Skeleton from "react-loading-skeleton"
import TableContainer from "components/newTables/TableContainer"
import FabricOrderAPI from "helpers/fabric_order_backend_helper"

export default function FabricPurchaseManagement() {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useSelector(state => state)
  const [pagination, setPagination] = useState({
    page: 0,
    size: 10,
  })
  const [params, setParams] = React.useState({
    page: 0,
    size: 10,
    tradingCompanyName: "",
    orderDateFrom: "",
    orderDateTo: "",
    status: "",
  })
  const [filter, setFilter] = useState({
    tradingCompanyName: "",
    orderDateFrom: "",
    orderDateTo: "",
    status: "",
  })

  const [grandTotal, setGrandTotal] = useState(0)
  const fetchGrandTotal = async () => {
    const res = await FabricOrderAPI.getGrandTotal()

    setGrandTotal(res.data.orderAmount)
  }

  useEffect(() => {
    fetchGrandTotal()
  }, [])

  const columns = React.useMemo(
    () => [
      {
        Header: "発注日付",
        accessor: "orderDate",
        defaultCanSort: false,
        Footer: info => {
          const total = React.useMemo(
            () =>
              info.rows.reduce((sum, row) => row.values.orderAmount + sum, 0),
            [info.rows]
          )
          return (
            <>
              <tr>
                <td></td>

                <td></td>
                <td>小計</td>
                <td>{total.toLocaleString("ja-JP")}</td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>

                <td>総合計</td>
                <td>{grandTotal.toLocaleString("ja-JP")}</td>
                <td></td>
                <td></td>
              </tr>
            </>
          )
        },
      },
      {
        Header: "商社",
        accessor: "tradingCompanyName",
        defaultCanSort: false,
        Footer: () => {
          return <tr className="d-none"></tr>
        },
      },
      {
        Header: "発注番号",
        accessor: "orderNumber",
        defaultCanSort: false,
        Footer: () => {
          return <tr className="d-none"></tr>
        },
      },
      {
        Header: "発注金額",
        accessor: "orderAmount",
        Cell: cell => {
          return <>{cell?.row?.original?.orderAmount.toLocaleString("ja-JP")}</>
        },
        defaultCanSort: false,
        Footer: () => {
          return <tr className="d-none"></tr>
        },
      },
      {
        Header: "ステータス",
        accessor: "status",
        defaultCanSort: false,
        Footer: () => {
          return <tr className="d-none"></tr>
        },
      },
      {
        Header: "",
        accessor: "name",
        defaultCanSort: false,
        Footer: () => {
          return <tr className="d-none"></tr>
        },
        Cell: ({ cell }) => (
          <Button
            className="btn-sm button"
            onClick={() =>
              history.push(
                `/inventory-control/fabric-purchase-management/${cell.row.original.id}`
              )
            }
          >
            詳細
          </Button>
        ),
      },
    ],
    [grandTotal]
  )

  React.useEffect(() => {
    dispatch(FabricOrderAction.getListPage({ ...params, ...pagination }))
  }, [params, pagination])

  const onChangeFilter = e => {
    setFilter({ ...filter, [e.target.name]: e.target.value })
  }

  const onSearch = () => {
    setPagination({ page: 0, size: 10 })
    setParams({
      ...filter,
      page: 0,
      size: 10,
    })
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title={"生地仕入管理"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col md={3}>
                <TextInputWithLabel
                  label={"商社"}
                  placeholder={""}
                  value={filter.tradingCompanyName}
                  type="text"
                  name="tradingCompanyName"
                  onChange={onChangeFilter}
                />
              </Col>
              <Col md={6}>
                <Label>発注日付</Label>
                <div className="d-flex gap-2 align-items-center">
                  <DateInput
                    className="form-control"
                    value={filter.orderDateFrom}
                    onChange={date => {
                      setFilter({
                        ...filter,
                        orderDateFrom: date[0],
                      })
                    }}
                    clear={() =>
                      setFilter({
                        ...filter,
                        orderDateFrom: "",
                      })
                    }
                  />
                  <span>~</span>
                  <DateInput
                    className="form-control"
                    value={filter.orderDateTo}
                    minDate={filter.orderDateFrom}
                    onChange={date =>
                      setFilter({ ...filter, orderDateTo: date[0] })
                    }
                    clear={() =>
                      setFilter({
                        ...filter,
                        orderDateTo: "",
                      })
                    }
                  />
                </div>
              </Col>

              <Col md={2}>
                <Label>ステータス</Label>
                <Select
                  placeholder={""}
                  value={{
                    value: filter.status,
                    label: filter.status,
                  }}
                  options={[
                    {
                      label: "新規発注",
                      value: "新規発注",
                    },
                    {
                      label: "一部納品済み",
                      value: "一部納品済み",
                    },
                    {
                      label: "納品済み",
                      value: "納品済み",
                    },
                  ]}
                  onChange={e => {
                    if (e) {
                      setFilter({
                        ...filter,
                        status: e.value,
                      })
                    }
                  }}
                />
              </Col>
              <Col className="d-flex align-items-end justify-content-start">
                <SButton className=" button" onClick={() => onSearch()}>
                  検索
                </SButton>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <Row className="mb-3">
              <Col sm="6" />
              <Col
                sm="6"
                className="d-flex align-items-end justify-content-end"
              >
                <SButton
                  className="mx-2 button"
                  onClick={() =>
                    history.push(
                      "/inventory-control/fabric-purchase-management/add"
                    )
                  }
                >
                  生地発注
                </SButton>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                {store.fabricOrder.pageData.loading ? (
                  <Skeleton count={5} />
                ) : store.fabricOrder.pageData.data?.content?.length === 0 ? (
                  <h3 className="text-center">No Data to Display</h3>
                ) : (
                  <TableContainer
                    data={store.fabricOrder.pageData.data?.content || []}
                    columns={columns}
                    pagination
                    page={pagination.page}
                    size={pagination.size}
                    count={store.fabricOrder.pageData.data?.totalPages || 1}
                    setParams={setPagination}
                    params={pagination}
                    footer
                  />
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}
